import { Tag } from '#app/components/ui/tag'

export default function IntegralProtectionSection() {
	return (
		<section className="px-4 py-4 md:px-4 md:py-4">
			<div
				className="rounded-[24px] bg-gradient-to-r from-blue-500 to-green-500 px-6 py-8 md:px-24 md:py-[104px]"
				style={{
					background:
						'linear-gradient(90deg, var(--blue-500) 0%, var(--green-500) 100%)',
				}}
			>
				<div className="container mx-auto max-w-[1200px] px-0 md:px-4">
					<div className="mb-8 md:mb-14">
						<Tag
							variant="secondary"
							appearance="solid"
							color="blue"
							size="l"
							option="text-icon-left"
							leftIcon="service"
						>
							Participación
						</Tag>
					</div>

					<div className="flex flex-col items-center gap-8 md:flex-row md:gap-[100px]">
						{/* Text Content */}
						<div className="flex-1">
							<h2 className="font-parkinsans mb-6 text-[36px] leading-[48px] font-medium text-white md:text-[48px] md:leading-[64px]">
								Proteger el agua desde una mirada integral y con impacto
								territorial
							</h2>
							<p className="font-inter text-base leading-[26px] text-white">
								Como ONG con base local, tenemos la capacidad de articular con
								comunidades, generar conciencia en territorio y movilizar
								voluntades desde abajo hacia arriba, promoviendo una ciudadanía
								activa y comprometida con la gestión sostenible del agua.
							</p>
						</div>

						{/* Image */}
						<div className="w-full flex-1 md:w-auto">
							<img
								src="/resources/images?src=/img/fondo-de-agua/rio-mendoza.png&w=616&h=620&format=webp"
								alt="Protección integral del agua"
								className="h-[400px] w-full rounded-[24px] object-cover md:h-[620px]"
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}
